/* eslint-disable react-hooks/exhaustive-deps */
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useState, useMemo, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import Button from '../../components/Button';
import EditableAvatar from '../../components/EditableAvatar';
import Stepper from '../../components/Stepper';
import {
  VerifyDependentStep1,
  VerifyDependentStep2,
  VerifyDependentStep3,
  VerifyDependentStep4,
} from '../../pages/widgets/verifyDependent/';
import { VdProvider } from '../../providers/vd';
import { getAllProfiles } from '../../services/profiles';
import CompletedPage from '../widgets/verifyDependent/completedPage';
import { stepScrollToTop } from '../../utils/utils';

const step1InitialData = {
  dependentRelationship: undefined,
  dependentRelationshipText: '',
  isDisabled: undefined,
  isFullTimeStudent: undefined,
  semesterLength: undefined,
};

const step2InitialData = {
  birthCertificateOption: undefined,
  isFileValid: false,
};

const step3InitialData = {
  ssn: undefined,
  isValid: false,
};

const step4InitialData = {
  hasAccepted: undefined,
};

const VerifyDependentView = () => {
  const [step, setStep] = useState(0);

  const [step1, setStep1] = useState(step1InitialData);
  const [step2, setStep2] = useState(step2InitialData);
  const [step3, setStep3] = useState(step3InitialData);
  const [step4, setStep4] = useState(step4InitialData);

  const isStep1Valid = useMemo(() => {
    const {
      dependentRelationship,
      dependentRelationshipText,
      isDisabled,
      isFullTimeStudent,
      semesterLength,
    } = step1;

    if (
      !dependentRelationship ||
      (dependentRelationship === '6' &&
        /^\s*$/.test(dependentRelationshipText)) ||
      !isDisabled ||
      !isFullTimeStudent
    ) {
      return false;
    }

    if (isFullTimeStudent === 'yes' && !semesterLength) {
      return false;
    }

    return true;
  }, [step1]);

  const isStep2Valid = useMemo(() => {
    const { birthCertificateOption, isFileValid } = step2;

    if (!birthCertificateOption) {
      return false;
    }

    if (birthCertificateOption === '1' && !isFileValid) {
      return false;
    }

    return true;
  }, [step2]);

  const isStep3Valid = useMemo(() => {
    const { ssn, isValid } = step3;

    if (!ssn || !isValid) {
      return false;
    }

    return true;
  }, [step3]);

  const isStep4Valid = useMemo(() => {
    const { hasAccepted } = step4;

    if (!hasAccepted) {
      return false;
    }

    return true;
  }, [step4]);

  const handleStep1Data = (data: any) => {
    setStep1(data);
  };

  const handleStep2Data = (data: any) => {
    setStep2(data);
  };

  const handleStep3Data = (data: any) => {
    setStep3(data);
  };

  const handleStep4Data = (data: any) => {
    setStep4(data);
  };

  const changeStep = (step: number) => {
    if (step === 0) {
      setStep1(step1InitialData);
    }

    if (step <= 1) {
      setStep2(step2InitialData);
    }

    if (step <= 2) {
      setStep3(step3InitialData);
    }

    if (step <= 3) {
      setStep4(step4InitialData);
    }

    setStep(step);
  };

  const steps = [
    {
      title: 'Relationship',
      child: (
        <VerifyDependentStep1 data={step1} collectStepData={handleStep1Data} />
      ),
    },
    {
      title: 'Documentation',
      child: (
        <VerifyDependentStep2 data={step2} collectStepData={handleStep2Data} />
      ),
    },
    {
      title: 'Social Security Number',
      child: (
        <VerifyDependentStep3 data={step3} collectStepData={handleStep3Data} />
      ),
    },
    {
      title: ' Confirmation',
      child: (
        <VerifyDependentStep4
          data={step4}
          goToStep={changeStep}
          collectStepData={handleStep4Data}
        />
      ),
    },
  ];

  const handleStepForward = () => {
    setStep(step + 1);
  };

  const handleStepBackward = () => {
    setStep(step - 1);
  };

  const profile = getAllProfiles().data.filter((x) => x.id === '5');

  useEffect(() => {
    stepScrollToTop();
  }, [step]);

  return (
    <Container className={'cnd-custom-container-small mb-12 px-lg-9 px-xl-0'}>
      {step === steps.length ? (
        <CompletedPage />
      ) : (
        <>
          <Container className="my-12 mx-0 px-0">
            <h4 className="m-0">{'Verify Dependent'}</h4>
          </Container>
          <Container className="mb-12 mx-0 px-0">
            <EditableAvatar name={profile[0].name} variant={'static'}>
              {
                <>
                  <h4 className={'text-sm-24-lg-32  fw-bold'}>Andy Smith</h4>
                  <span className={'fw-light'} style={{ color: '#2F55DD' }}>
                    (Family member eligibility requirement)
                  </span>
                </>
              }
            </EditableAvatar>
          </Container>
          <Container className="mb-12 mx-0 px-0">
            <Stepper currentStepIndex={step} steps={steps} />
          </Container>
          <section className="d-flex flex-column flex-lg-row justify-content-center">
            <Button
              variant="primary-outline"
              leftIcon={light('arrow-left')}
              onClick={handleStepBackward}
              disabled={step === 0}
              className={`mx-lg-10 ${
                step === 0 && 'd-none'
              } order-2 order-lg-1 mt-7 mt-lg-0`}
            >
              Previous
            </Button>
            <Button
              variant="primary-outline"
              onClick={() => console.log('CANCEL')}
              className={'mx-lg-10 order-3 order-lg-2 mt-7 mt-lg-0'}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              disabled={
                (step === 0 && !isStep1Valid) ||
                (step === 1 && !isStep2Valid) ||
                (step === 2 && !isStep3Valid) ||
                (step === 3 && !isStep4Valid)
              }
              onClick={handleStepForward}
              className={'mx-lg-10 order-1 order-lg-3'}
            >
              {step === steps.length - 1 ? 'Submit' : 'Continue'}
            </Button>
          </section>
        </>
      )}
    </Container>
  );
};

function Dashboard() {
  return (
    <VdProvider>
      <VerifyDependentView />
    </VdProvider>
  );
}

export default Dashboard;
